export default __webpack_public_path__ + "static/media/active-builder-badge.775e5611.png";